import { Col, Form, Row } from 'react-bootstrap';
import { HiOutlinePlus } from 'react-icons/hi';
import { Button } from '@Components/Button/Button';
import { Size } from '@Components/designConstants';
import { WtoVariant } from '../wto-form-context';
import { VariantRow } from './VariantRow';

interface VariantsSectionProps {
  variants: WtoVariant[];
  readOnly: boolean;
  onVariantChange: (index: number, variant: WtoVariant) => void;
  onVariantDelete: (index: number) => void;
  onAddVariant: () => void;
}

export const VariantsSection = ({
  variants,
  readOnly,
  onVariantChange,
  onVariantDelete,
  onAddVariant
}: VariantsSectionProps) => (
  <Row>
    <Form.Group as={Col} className='form-group'>
      <Form.Label>Variants</Form.Label>
      <div className='helper-text'>
        <p>
          Please enter a full variant URL, starting with HTTPS.
          <br />
          <br />
          Example: https://www.insiderenvy.com/3-reasons-get-starz-v3-title1-syft
          <br />
          <br />
          Additional notes on the Variant URL Parameter:
        </p>
        <ul>
          <li>Please do not enter URL Parameters (UTMs) on this screen</li>
          <li>
            If you need to specify, change, or add, URL Parameters (UTMs) in the URL, please use the
            URL Parameter functionality on the Rules screen
          </li>
          <li>
            All incoming URL parameters will be carried over to the Variant URL, unless they are
            modified using URL Parameter functionality on the Rules screen
          </li>
        </ul>
      </div>
      <div className='variants-wrapper'>
        {variants.map((variant: WtoVariant, index: number) => (
          <VariantRow
            key={index}
            variant={variant}
            index={index}
            readOnly={readOnly}
            showDelete={variants.length > 1 && !readOnly}
            onChange={onVariantChange}
            onDelete={onVariantDelete}
          />
        ))}
      </div>
      {!readOnly && (
        <Button
          size={Size.LG}
          leadingElement={<HiOutlinePlus />}
          onClick={e => {
            e.preventDefault();
            onAddVariant();
          }}
        >
          Add Variant
        </Button>
      )}
    </Form.Group>
  </Row>
);
